import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as moment from 'moment';
import { VendorService } from '../../vendor-portal/vendor.service';

@Component({
  selector: 'app-new-customers-dialog',
  templateUrl: './new-customers-dialog.component.html',
  styleUrls: ['./new-customers-dialog.component.css']
})
export class NewCustomersDialogComponent implements OnInit {

  customers = [];
  loading = false;
  errorMessage = '';
  rangeLabel = '';

  constructor(
    public dialogRef: MatDialogRef<NewCustomersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { start: moment.Moment; end: moment.Moment },
    private vendorService: VendorService
  ) { }

  ngOnInit() {
    const start = this.data && this.data.start ? moment(this.data.start) : null;
    const end = this.data && this.data.end ? moment(this.data.end) : null;
    if (start && end && start.isValid() && end.isValid()) {
      this.rangeLabel = `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`;
      this.loadCustomers(start, end);
    } else {
      this.errorMessage = 'Invalid date range selected.';
    }
  }

  close() {
    this.dialogRef.close();
  }

  getInitials(name: string): string {
    if (!name) {
      return '?';
    }
    return name.split(/\s+/).map(n => n.charAt(0)).join('').toUpperCase().substring(0, 2) || '?';
  }

  private loadCustomers(start: moment.Moment, end: moment.Moment) {
    this.loading = true;
    this.errorMessage = '';
    this.vendorService.getCustomerList(1, 5000).then((res) => {
      const list = (res && res.data) || [];
      const startMs = start.valueOf();
      const endMs = end.valueOf();
      this.customers = list.filter((customer) => {
        if (!customer || !customer.created_at) {
          return false;
        }
        const created = moment(customer.created_at);
        if (!created.isValid()) {
          return false;
        }
        const t = created.valueOf();
        return t >= startMs && t <= endMs;
      }).sort((a, b) => {
        return moment(b.created_at).valueOf() - moment(a.created_at).valueOf();
      });
      this.loading = false;
    }).catch((e) => {
      console.error(e);
      this.loading = false;
      this.errorMessage = 'Failed to load new customers. Please try again.';
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-dashboard/new-customers-dialog/new-customers-dialog.component.ts